import * as React from "react";

import type { DesignaliProps } from "../../types";

export const LaurelWreath01 = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({  ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path  d="M6.44,8c-.28.84-.44,1.76-.44,2.73,0,4.02,2.69,7.27,6,7.27s6-3.26,6-7.27c0-.96-.15-1.89-.44-2.73"/>
  <path  d="M14.5,21s-.68-3-2.5-3-2.5,3-2.5,3"/>
  <path  d="M18.52,5.23c.29,1.67-1.02,2.77-1.02,2.77,0,0-1.6-.56-1.9-2.23-.29-1.67,1.02-2.77,1.02-2.77,0,0,1.6.56,1.9,2.23Z"/>
  <path  d="M21.09,12.14c-1.28,1.27-3.02.76-3.02.76,0,0-.45-1.77.83-3.04,1.28-1.27,3.02-.76,3.02-.76,0,0,.45,1.77-.83,3.04Z"/>
  <path  d="M18.23,18.19c-1.5-.58-1.73-2.19-1.73-2.19,0,0,1.27-1.04,2.77-.46,1.5.58,1.73,2.19,1.73,2.19,0,0-1.27,1.04-2.77.46Z"/>
  <path  d="M5.77,18.19c1.5-.58,1.73-2.19,1.73-2.19,0,0-1.27-1.04-2.77-.46s-1.73,2.19-1.73,2.19c0,0,1.27,1.04,2.77.46Z"/>
  <path  d="M2.91,12.14c1.28,1.27,3.02.76,3.02.76,0,0,.45-1.77-.83-3.04-1.28-1.27-3.02-.76-3.02-.76,0,0-.45,1.77.83,3.04Z"/>
  <path  d="M5.48,5.23c-.29,1.67,1.02,2.77,1.02,2.77,0,0,1.6-.56,1.9-2.23.29-1.67-1.02-2.77-1.02-2.77,0,0-1.6.56-1.9,2.23Z"/>
</svg>
    );
  },
);

export default LaurelWreath01;
